import React, { createContext, useContext, useMemo } from 'react'

import type { Source } from '@/types/chat-v2'
import type { File } from '@/types/File'
import type { UUID } from '@/types/Id'

export type ChatCitationViewerTab = 'files' | 'citations'

interface ChatCitationInteractionContextValue {
  filesById: Map<UUID, File>
  openSources: (sources: Source[], tab?: ChatCitationViewerTab) => void
}

const ChatCitationInteractionContext =
  createContext<ChatCitationInteractionContextValue | null>(null)

interface ChatCitationInteractionProviderProps {
  filesById: Map<UUID, File>
  openSources: (sources: Source[], tab?: ChatCitationViewerTab) => void
  children: React.ReactNode
}

export const ChatCitationInteractionProvider: React.FC<
  ChatCitationInteractionProviderProps
> = ({ filesById, openSources, children }) => {
  const value = useMemo(
    () => ({ filesById, openSources }),
    [filesById, openSources],
  )

  return (
    <ChatCitationInteractionContext.Provider value={value}>
      {children}
    </ChatCitationInteractionContext.Provider>
  )
}

export const useChatCitationInteraction = () => {
  return useContext(ChatCitationInteractionContext)
}
